export default "__VITE_ASSET__DEwabek4__"